// @ts-nocheck
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import getTaskTypes from '@scale/frontend-lib/getTaskTypes';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'design-system/Modal';
import { Label, Button } from 'design-system/Form';
import TaskerPermissionsTable from './TaskerPermissionsTable';
import { ProjectDisableReasonPicker } from './ProjectDisableReasonPicker';

class TaskerPermissionsModal extends Component<$FIXME> {
  static propTypes = {
    isModalOpen: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
    scaler: PropTypes.object,
    filter: PropTypes.object,
  };

  state = {
    permissions: [],
    loading: true,
    newJobs: [],
    toRemove: [],
    toEnable: [],
    edited: 0,
    table: {
      page: 0,
      pageSize: 10,
    },
    taskTypes: [],
    closingModalOpen: false,
    savingModalOpen: false,
    projectDisableReasonModalOpen: false,
    currentDisableProjectIndex: null,
  };

  resetState() {
    this.setState({
      permissions: [],
      loading: true,
      newJobs: [],
      toRemove: [],
      toEnable: [],
      edited: 0,
      table: {
        page: 0,
        pageSize: 10,
      },
      taskTypes: [],
      closingModalOpen: false,
      savingModalOpen: false,
      projectDisableReasonModalOpen: false,
      currentDisableProjectIndex: null,
    });
  }

  async fetchTasks() {
    const jobs = await apiFetch(
      null,
      `internal/permissions/jobs?worker_id=${this.props.scaler.id}`,
    );
    let permissions = jobs[0].enabledTaskPermissions.map(job => ({
      job,
      type: 'saved',
    }));
    if (this.props.filter) {
      permissions = permissions.filter(
        p =>
          !this.props.filter.permissionGroup ||
          this.props.filter.permissionGroup === p.job.permissionGroup?._id,
      );
    }
    return permissions;
  }

  async componentDidMount() {
    await this.loadComponent();
  }

  async componentDidUpdate(prevProps) {
    if (!prevProps.isModalOpen && this.props.isModalOpen) {
      await this.loadComponent();
    }
  }

  async loadComponent() {
    try {
      const permissions = await this.fetchTasks();
      this.setState({
        permissions,
        taskTypes: getTaskTypes(),
      });
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
    } finally {
      this.setState({
        loading: false,
      });
    }
  }

  updatePermission(index, path, value) {
    const newJob = index >= this.state.permissions.length;
    const data = [...(newJob ? this.state.newJobs : this.state.permissions)];
    const newIndex = newJob ? index - this.state.permissions.length : index;
    _.set(data[newIndex], path, value);
    const state = {};
    state[newJob ? 'newJobs' : 'permissions'] = data;
    this.setState(state);
  }

  cancelRemove(index) {
    const permissions = [...this.state.permissions];
    permissions.splice(index, 1, { ...permissions[index], remove: false });
    const toRemove = { ...this.state.toRemove };
    delete toRemove[`${index}`];
    this.setState({
      toRemove,
      permissions,
    });
  }

  cancelEnable(index) {
    const permissions = [...this.state.permissions];
    permissions.splice(index, 1, { ...permissions[index], enable: false });
    const toEnable = { ...this.state.toEnable };
    delete toEnable[`${index}`];
    this.setState({
      toEnable,
      permissions,
    });
  }

  editPermission(index) {
    const permissions = [...this.state.permissions];
    permissions.splice(index, 1, { ...permissions[index], editable: true });
    permissions[index].original = { ...permissions[index].job };
    this.setState({
      permissions,
      edited: this.state.edited + 1,
    });
  }

  cancelEditPermission(index) {
    const permissions = [...this.state.permissions];
    permissions.splice(index, 1, { ...permissions[index], editable: false });
    permissions[index].job = { ...permissions[index].original };
    this.setState({
      permissions,
      edited: this.state.edited - 1,
    });
  }

  removeNew(index) {
    const newIndex = index - this.state.permissions.length;
    const newJobs = [...this.state.newJobs];
    newJobs.splice(newIndex, 1);
    this.setState({
      newJobs,
    });
  }

  removePermission(reason) {
    const permissions = [...this.state.permissions];
    permissions.splice(this.state.currentDisableProjectIndex, 1, {
      ...permissions[this.state.currentDisableProjectIndex],
      remove: true,
      disableReason: reason,
    });
    const newRemove = {};
    newRemove[`${this.state.currentDisableProjectIndex}`] = {
      ...permissions[this.state.currentDisableProjectIndex],
    };

    this.setState({
      toRemove: { ...this.state.toRemove, ...newRemove },
      permissions,
      projectDisableReasonModalOpen: false,
      currentDisableProjectIndex: null,
    });
  }

  enablePermission(index) {
    const permissions = [...this.state.permissions];
    permissions.splice(index, 1, { ...permissions[index], enable: true });
    const newEnable = {};
    newEnable[`${index}`] = permissions[index];
    this.setState({
      toEnable: { ...this.state.toEnable, ...newEnable },
      permissions,
    });
  }

  handleNewJob() {
    const newJobs = this.state.newJobs.concat({
      job: { taskType: null, taskCustomer: {}, canReview: false, permissionGroup: null },
      type: 'new',
    });
    const page = Math.floor(
      (this.state.permissions.length + newJobs.length - 1) / this.state.table.pageSize,
    );
    this.setState({
      newJobs,
      table: Object.assign(this.state.table, { page }),
    });
  }

  hasChanges() {
    return (
      !!this.state.edited ||
      !!this.state.newJobs.length ||
      !!Object.keys(this.state.toRemove).length ||
      !!Object.keys(this.state.toEnable).length
    );
  }

  handleClose(sure) {
    const hasChanges = this.hasChanges();
    if (sure || !hasChanges) {
      this.resetState();
      return this.props.hideModal();
    }
    this.setState({
      closingModalOpen: !sure && hasChanges,
    });
  }

  async handleSave(sure) {
    if (!sure) {
      return this.setState({
        savingModalOpen: true,
      });
    }
    this.setState({
      saving: true,
    });
    try {
      const formatPermissions = permissionsList => {
        return permissionsList.map(p => {
          const job = { ...p.job };
          job.permissionGroup = (job.permissionGroup && job.permissionGroup._id) || null;
          job.taskCustomer = (job.taskCustomer && job.taskCustomer.id) || null;
          job.worker = this.props.scaler.id;
          job.disableReason = p.disableReason;
          return _.pick(job, [
            'worker',
            'taskType',
            'taskCustomer',
            'permissionGroup',
            'canAttempt',
            'canReview',
            'reviewLevel',
            'corpReviewSampleRate',
            'disableReason',
          ]);
        });
      };

      await apiFetch(null, `internal/permissions/update`, {
        method: 'POST',
        body: {
          addPermissions: formatPermissions([
            ...this.state.newJobs,
            ...this.state.permissions.filter(p => p.editable),
          ]),
          enablePermissions: formatPermissions(_.values(this.state.toEnable)),
          removePermissions: formatPermissions(_.values(this.state.toRemove)),
        },
      });
      alert('Changes applied successfully!');
      this.handleClose(true);
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
    }
    this.setState({
      saving: false,
      savingModalOpen: false,
    });
  }

  render() {
    return (
      <Modal
        isOpen={this.props.isModalOpen}
        contentLabel="Scaler Permission Modal"
        onRequestClose={() => this.handleClose()}
        maxWidth="1500px"
      >
        <ModalHeader onRequestClose={() => this.handleClose()}>
          Enabled tasks for{' '}
          {`${this.props.scaler.firstName || '-'} ${this.props.scaler.lastName || '-'} (${
            this.props.scaler.email
          })`}
        </ModalHeader>
        <ModalBody>
          <TaskerPermissionsTable
            loggedUserIsAdmin={this.props.loggedUserIsAdmin || false}
            scalerId={this.props.scaler.id}
            loading={this.state.loading}
            data={this.state.permissions.concat(this.state.newJobs)}
            pageSize={this.state.table.pageSize}
            onPageChange={page =>
              this.setState({ table: Object.assign(this.state.table, { page }) })
            }
            page={this.state.table.page}
            onPageSizeChange={pageSize =>
              this.setState({ table: Object.assign(this.state.table, { pageSize }) })
            }
            taskTypes={this.state.taskTypes}
            updatePermission={this.updatePermission.bind(this)}
            removeNew={this.removeNew.bind(this)}
            cancelRemove={this.cancelRemove.bind(this)}
            removePermission={index =>
              this.setState({
                projectDisableReasonModalOpen: true,
                currentDisableProjectIndex: index,
              })
            }
            cancelEnable={this.cancelEnable.bind(this)}
            enablePermission={this.enablePermission.bind(this)}
            editPermission={this.editPermission.bind(this)}
            cancelEditPermission={this.cancelEditPermission.bind(this)}
          />
        </ModalBody>
        <ModalFooter>
          <Button type="button" onClick={this.handleNewJob.bind(this)}>
            Add New
          </Button>
          <Button
            type="button"
            onClick={() => this.handleSave()}
            disabled={
              !this.hasChanges() ||
              !this.state.newJobs.reduce(
                (valids, original) =>
                  valids && (!!original.job.taskType || !!original.job.permissionGroup),
                true,
              )
            }
          >
            Save and Close
          </Button>
          <Button type="button" onClick={() => this.handleClose()}>
            Close
          </Button>
        </ModalFooter>
        <ProjectDisableReasonPicker
          show={this.state.projectDisableReasonModalOpen}
          key={this.state.currentDisableProjectIndex}
          disabled={false}
          onConfirm={reason => this.removePermission(reason)}
          onClose={() =>
            this.setState({
              projectDisableReasonModalOpen: false,
              currentDisableProjectReason: '',
              currentDisableProjectIndex: null,
            })
          }
        />
        <Modal
          isOpen={this.state.closingModalOpen}
          contentLabel="Scaler Permission Modal"
          onRequestClose={this.props.hideModal}
          maxWidth="1280px"
        >
          <ModalHeader onRequestClose={() => this.setState({ closingModalOpen: false })}>
            {`You're about to close without saving changes`}
          </ModalHeader>
          <ModalBody>
            <Label>{`You're about to close this permission without saving your pending changes:`}</Label>
            <ul>
              <li>New Items: {this.state.newJobs.length}</li>
              <li>Updated Items: {this.state.edited}</li>
              <li>To Disable: {Object.keys(this.state.toRemove).length}</li>
              <li>To Enable: {Object.keys(this.state.toEnable).length}</li>
            </ul>
            <Label>Are you sure to lose your changes?</Label>
          </ModalBody>
          <ModalFooter>
            <Button type="button" onClick={() => this.handleClose(true)}>{`Yes, I'm Sure`}</Button>
            <Button type="button" onClick={() => this.setState({ closingModalOpen: false })}>
              No
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.savingModalOpen}
          contentLabel="Scaler Permission Modal"
          onRequestClose={this.props.hideModal}
          maxWidth="1280px"
        >
          <ModalHeader onRequestClose={() => this.setState({ savingModalOpen: false })}>
            {`You're about to save your changes`}
          </ModalHeader>
          <ModalBody>
            <Label>{`This is a brief of your changes:`}</Label>
            <ul>
              <li>New Items: {this.state.newJobs.length}</li>
              <li>Updated Items: {this.state.edited}</li>
              <li>To Disable: {Object.keys(this.state.toRemove).length}</li>
              <li>To Enable: {Object.keys(this.state.toEnable).length}</li>
            </ul>
            <Label>Do you want to continue and save it?</Label>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              disabled={this.state.saving}
              onClick={() => this.handleSave(true)}
            >
              Yes, Go ahead
            </Button>
            <Button
              type="button"
              disabled={this.state.saving}
              onClick={() => this.setState({ savingModalOpen: false })}
            >
              No
            </Button>
          </ModalFooter>
        </Modal>
      </Modal>
    );
  }
}

export default TaskerPermissionsModal;
